import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Trashcan = ({
  size,
  type,
  theme,
  className,
  dataTestId = "trashcan-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M9.87212 6.99617C10.2394 7.02273 10.5155 7.34195 10.489 7.70918L10.2445 11.09C10.2179 11.4573 9.89871 11.7334 9.53148 11.7069C9.16424 11.6803 8.88807 11.3611 8.91463 10.9939L9.15911 7.61302C9.18566 7.24579 9.50489 6.96961 9.87212 6.99617Z" />
    <path d="M7.08793 10.9945C7.11448 11.3617 6.83831 11.6809 6.47108 11.7075C6.10385 11.734 5.78462 11.4579 5.75807 11.0906L5.51359 7.70977C5.48703 7.34254 5.7632 7.02331 6.13043 6.99676C6.49766 6.9702 6.81689 7.24638 6.84345 7.61361L7.08793 10.9945Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.20192 2.12331C4.20192 1.38693 4.79888 0.789978 5.53526 0.789978H10.4646C11.201 0.789978 11.798 1.38693 11.798 2.12331V3.43842H14.9292C15.2974 3.43842 15.5959 3.73689 15.5959 4.10508C15.5959 4.47327 15.2974 4.77175 14.9292 4.77175H14.1263L13.0826 13.4481C12.9617 14.453 12.1091 15.2092 11.0969 15.2092H4.90467C3.89249 15.2092 3.03987 14.453 2.91899 13.4481L1.87528 4.77175H1.07041C0.702224 4.77175 0.403748 4.47327 0.403748 4.10508C0.403748 3.73689 0.702224 3.43842 1.07041 3.43842H4.20192V2.12331ZM3.21823 4.77175L4.24278 13.2889C4.28307 13.6238 4.56728 13.8759 4.90467 13.8759H11.0969C11.4343 13.8759 11.7185 13.6238 11.7588 13.2889L12.7834 4.77175H3.21823ZM10.4646 2.12331V3.43842H5.53526V2.12331L10.4646 2.12331Z"
    />
  </SVGIcon>
);
